<template>
  <div class="d-flex">
    <img v-if="img === 'unknown'" :height="size - 5" src="@/assets/images/logo-icon.png" />
    <img v-if="img === '01'" :height="size" src="@/assets/images/categories/CATEGORY ICON-01.png" />
    <img v-if="img === '02'" :height="size" src="@/assets/images/categories/CATEGORY ICON-02.png" />
    <img v-if="img === '03'" :height="size" src="@/assets/images/categories/CATEGORY ICON-03.png" />
    <img v-if="img === '04'" :height="size" src="@/assets/images/categories/CATEGORY ICON-04.png" />
    <img v-if="img === '05'" :height="size" src="@/assets/images/categories/CATEGORY ICON-05.png" />
    <img v-if="img === '06'" :height="size" src="@/assets/images/categories/CATEGORY ICON-06.png" />
    <img v-if="img === '07'" :height="size" src="@/assets/images/categories/CATEGORY ICON-07.png" />
    <img v-if="img === '08'" :height="size" src="@/assets/images/categories/CATEGORY ICON-08.png" />
    <img v-if="img === '09'" :height="size" src="@/assets/images/categories/CATEGORY ICON-09.png" />
    <img v-if="img === '10'" :height="size" src="@/assets/images/categories/CATEGORY ICON-10.png" />
    <img v-if="img === '11'" :height="size" src="@/assets/images/categories/CATEGORY ICON-11.png" />
    <img v-if="img === '12'" :height="size" src="@/assets/images/categories/CATEGORY ICON-12.png" />
    <img v-if="img === '13'" :height="size" src="@/assets/images/categories/CATEGORY ICON-13.png" />
    <img v-if="img === '14'" :height="size" src="@/assets/images/categories/CATEGORY ICON-14.png" />
    <img v-if="img === '15'" :height="size" src="@/assets/images/categories/CATEGORY ICON-15.png" />
    <img v-if="img === '16'" :height="size" src="@/assets/images/categories/CATEGORY ICON-16.png" />
    <img v-if="img === '17'" :height="size" src="@/assets/images/categories/CATEGORY ICON-17.png" />
    <img v-if="img === '18'" :height="size" src="@/assets/images/categories/CATEGORY ICON-18.png" />
    <img v-if="img === '19'" :height="size" src="@/assets/images/categories/CATEGORY ICON-19.png" />
    <img v-if="img === '20'" :height="size" src="@/assets/images/categories/CATEGORY ICON-20.png" />
    <img v-if="img === '21'" :height="size" src="@/assets/images/categories/CATEGORY ICON-21.png" />
    <img v-if="img === '22'" :height="size" src="@/assets/images/categories/CATEGORY ICON-22.png" />
    <img v-if="img === '23'" :height="size" src="@/assets/images/categories/CATEGORY ICON-23.png" />
    <img v-if="img === '24'" :height="size" src="@/assets/images/categories/CATEGORY ICON-24.png" />
    <img v-if="img === '25'" :height="size" src="@/assets/images/categories/CATEGORY ICON-25.png" />
    <img v-if="img === '26'" :height="size" src="@/assets/images/categories/CATEGORY ICON-26.png" />
    <img v-if="img === '27'" :height="size" src="@/assets/images/categories/CATEGORY ICON-27.png" />
    <img v-if="img === '28'" :height="size" src="@/assets/images/categories/CATEGORY ICON-28.png" />
    <img v-if="img === '29'" :height="size" src="@/assets/images/categories/CATEGORY ICON-29.png" />
    <img v-if="img === '30'" :height="size" src="@/assets/images/categories/CATEGORY ICON-30.png" />
    <img v-if="img === '31'" :height="size" src="@/assets/images/categories/CATEGORY ICON-31.png" />
  </div>
  <!--

  Icon but no category (at any level) in the database (OK?)
  ---
  
  | Icon                 | Category Display Name                          | Category Code                   |
  | -------------------- | ---------------------------------------------- | ------------------------------- |
  | CATEGORY ICON-06.png | Criminal Activity                              | ???                             |
  | CATEGORY ICON-15.png | Involvement in Theft                           | ???                             |
  | CATEGORY ICON-16.png | Knowledge of Involvement in Theft/Embezzlement | ???                             |
  | CATEGORY ICON-25.png | Unethical Relationships with Suppliers/Vendors | ???                             |

  
  Icon to category to lvl2 match (GOOD)
  ---
  
  | Icon                 | Category Display Name                          | Category Code                                  |
  | -------------------- | ---------------------------------------------- | ---------------------------------------------- |
  | CATEGORY ICON-01.png | Abuse of Authority                             | abuse-of-authority                             |
  | CATEGORY ICON-02.png | Affiliation with Criminal Gangs                | gang-affiliation                               |
  | CATEGORY ICON-02.png | Gang Affiliation                               | gang-affiliation                               |
  | CATEGORY ICON-03.png | Bribery                                        | bribery                                        |
  | CATEGORY ICON-04.png | BulIying                                       | bullying                                       |
  | CATEGORY ICON-05.png | Confidential Information                       | confidential-information                       |
  | CATEGORY ICON-07.png | Employee Theft                                 | employee-theft                                 |
  | CATEGORY ICON-07.png | Employee Theft (Time)                          | employee-theft-time                            |
  | CATEGORY ICON-08.png | Financial Stability                            | financial-stability                            |
  | CATEGORY ICON-09.png | General Conduct                                | general-conduct                                |
  | CATEGORY ICON-10.png | Giving Discounts/Credits                       | giving-discounts-credits                       |
  | CATEGORY ICON-11.png | Honesty/Integrity                              | honesty-integrity                              |
  | CATEGORY ICON-12.png | Illegal Drugs and Alcohol                      | illegal-drugs-and-alcohol                      |
  | CATEGORY ICON-13.png | Improper Relationships                         | improper-relationships                         |
  | CATEGORY ICON-14.png | Inappropriate Relationships                    | inappropriate-relationships                    |
  | CATEGORY ICON-17.png | Loyalty / Turnover / Motivation                | loyalty-turnover-motivation                    |
  | CATEGORY ICON-18.png | Personal Dealings                              | personal-dealings                              |
  | CATEGORY ICON-19.png | Pre-Existing Test Knowledge                    | pre-existing-test-knowledge                    |
  | CATEGORY ICON-20.png | Reliability of Reports                         | reliability-of-reports                         |
  | CATEGORY ICON-21.png | Reporting Inventory                            | reporting-inventory                            |
  | CATEGORY ICON-22.png | Sabotage/Vandalism                             | sabotage-vandalism                             |
  | CATEGORY ICON-23.png | Sexual Harassment                              | sexual-harassment                              |
  | CATEGORY ICON-24.png | Time Sheet Reporting                           | time-sheet-reporting                           |
  | CATEGORY ICON-25.png | Unethical Relationships with Suppliers         | unethical-relationships-with-suppliers-vendors |
  | CATEGORY ICON-26.png | Violence in the Workplace                      | violence-in-the-workplace                      |
  | CATEGORY ICON-27.png | Illegal Drugs                                  | illegal-drugs                                  |
  | CATEGORY ICON-28.png | Alcohol                                        | alcohol                                        |
  | CATEGORY ICON-29.png | Logistics Centers Code of Conduct              | logistics-centers-code-of-conduct              |
  | CATEGORY ICON-30.png | Corporate Espionage                            | corporate-espionage                            |
  | CATEGORY ICON-31.png | Unethical Relationships with Suppliers/Vendors | unethical-relationships-with-suppliers-vendors |
  -->
</template>

<script>
export default {
  props: {
    categoryCode: String,
    size: {
      type: Number,
      default: 46,
    },
  },
  data() {
    return {
      img: "unknown",
    };
  },
  watch: {
    categoryCode() {
      this.setImg();
    },
  },
  mounted() {
    this.setImg();
  },
  methods: {
    setImg() {
      this.img = "unknown";
      if (this.categoryCode === "abuse-of-authority") this.img = "01";
      if (this.categoryCode === "affiliation-with-criminal-gangs") this.img = "02";
      if (this.categoryCode === "gang-affiliation") this.img = "02";
      if (this.categoryCode === "bribery") this.img = "03";
      if (this.categoryCode === "bullying") this.img = "04";
      if (this.categoryCode === "protection-of-information") this.img = "05";
      if (this.categoryCode === "confidential-proprietary-information") this.img = "05";
      if (this.categoryCode === "confidential-information") this.img = "05";
      if (this.categoryCode === "employee-theft") this.img = "07";
      if (this.categoryCode === "employee-theft-time") this.img = "07";
      if (this.categoryCode === "financial-stability") this.img = "08";
      if (this.categoryCode === "general-conduct") this.img = "09";
      if (this.categoryCode === "general-conduct-warehouse-employee") this.img = "29";
      if (this.categoryCode === "logistics-centers-code-of-conduct") this.img = "29";
      if (this.categoryCode === "giving-discounts-credits") this.img = "10";
      if (this.categoryCode === "discount-credit-fraud") this.img = "10";
      if (this.categoryCode === "honesty-integrity") this.img = "11";
      if (this.categoryCode === "illegal-drugs-and-alcohol") this.img = "12";
      if (this.categoryCode === "improper-relationships") this.img = "13";
      if (this.categoryCode === "inappropriate-relationships") this.img = "14";
      if (this.categoryCode === "loyalty-turnover-motivation") this.img = "17";
      if (this.categoryCode === "personal-dealings") this.img = "18";
      if (this.categoryCode === "pre-existing-test-knowledge") this.img = "19";
      if (this.categoryCode === "interview-preparation") this.img = "19";
      if (this.categoryCode === "reliability-of-reports") this.img = "20";
      if (this.categoryCode === "reporting-inventory") this.img = "21";
      if (this.categoryCode === "sabotage-vandalism") this.img = "22";
      if (this.categoryCode === "sexual-harassment") this.img = "23";
      if (this.categoryCode === "time-sheet-reporting") this.img = "24";
      if (this.categoryCode === "unethical-relationships-with-suppliers-vendors") this.img = "31";
      if (this.categoryCode === "violence-in-the-workplace") this.img = "26";
      if (this.categoryCode === "illegal-drugs") this.img = "27";
      if (this.categoryCode === "alcohol") this.img = "28";
      if (this.categoryCode === "corporate-espionage") this.img = "30";
    },
  },
};
</script>
